import { render, staticRenderFns } from "./ReportingStories.vue?vue&type=template&id=241a5c3c&scoped=true"
import script from "./ReportingStories.vue?vue&type=script&lang=js"
export * from "./ReportingStories.vue?vue&type=script&lang=js"
import style0 from "./ReportingStories.vue?vue&type=style&index=0&id=241a5c3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a5c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241a5c3c')) {
      api.createRecord('241a5c3c', component.options)
    } else {
      api.reload('241a5c3c', component.options)
    }
    module.hot.accept("./ReportingStories.vue?vue&type=template&id=241a5c3c&scoped=true", function () {
      api.rerender('241a5c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingStories.vue"
export default component.exports